const state = {
	heroPromo: {},
	topSection: {},
	rowsSections: []
};

const mutations = {
	SET_HERO_PROMO(state, section) {
		state.heroPromo = section;
	},
	SAVE_TOP_SECTION(state, section) {
		state.topSection = section;
	},
	SAVE_ROWS_SECTIONS(state, sections) {
		state.rowsSections = sections;
	}
};

const actions = {
	setHeroPromo({ commit }, section) {
		commit("SET_HERO_PROMO", section);
	},
	saveTopSection({ commit }, section) {
		commit("SAVE_TOP_SECTION", section);
	},
	saveRowsSections({ commit }, sections) {
		commit("SAVE_ROWS_SECTIONS", sections);
	}
};

export default {
	namespaced: true,
	state,
	mutations,
	actions
};
